export default "__VITE_ASSET__D9dIpGzu__"